export const events: Record<string, string> = {
	event_BOX_IS_EMPTY: "The box was empty.",
	event_CANT_HEAL_ALREADY_FULL_HEALTH: "You are already at full health.",
	event_CANT_PUT_MINE_HERE: "Can't deploy a mine here.",
	event_CONTAINER_OPENS: "You opened the crate.",
	event_DEV_KILL_BOT_ACTIVATED: "Auto kill activated.",
	event_DEV_KILL_BOT_DEACTIVATED: "Auto kill deactivated.",
	event_DO_NOT_HAVE_KEY: "You need a key to open this crate.",
	event_EQUATION_FOUND: "You have found the equation!",
	event_EQUATION_IS_HERE: "The equation is here! You just need to take a closer look...",
	event_GOT_AMMO: "Got $1x",
	event_GOT_ITEM: "Got $1x",
	event_GOT_WEAPON: "You got the",
	event_LEVEL_DIRECTOR_HOSTILITY_REACHED_1: "More enemies are coming.",
	event_LEVEL_DIRECTOR_HOSTILITY_REACHED_2: "This area is getting dangerous.",
	event_LEVEL_DIRECTOR_HOSTILITY_REACHED_3: "Even more enemies approach.",
	event_LEVEL_DIRECTOR_HOSTILITY_REACHED_4: "They are very angry and are sending reinforcements.",
	event_LEVEL_DIRECTOR_HOSTILITY_REACHED_5: "BLOOD FOR THE BLOOD GOD!",
	event_NO_PATH_FOR_AUTOMOVE: "You don't know how to get there.",
	event_PLAYER_DIED: "You died.",
	event_PLAYER_FULLY_HEALED: "You are now fully healed!",
	event_PLAYER_HEALED: "You healed your wounds.",
	event_POWER_PLANT_ACTIVATED: "Power plant now online.",
	event_POWER_PLANT_GATE_NO_POWER: "Cannot open doors. No power.",
	event_POWER_PLANT_GATE_NO_KEYCARD: "Keycard required.",
	event_POWER_PLANT_GATE_OPENED: "Opening gates...",
	event_VENDING_MACHINE_NO_POWER: "No power",
	event_TERMINAL_NO_POWER: "No power",
	event_TERMINAL_NO_KEYCARD: "Keycard required.",
	event_FIRST_WEAPON_PICKUP: "",
	event_LOW_HP_MEDIKIT_HINT: "",
	event_HINT: "",
	event_REACHED_AREA: "You have reached: $1",
	event_TERMINAL_OPENED_BLAST_DOORS: "You access the terminal. The blast doors open!",
};
